import styles from './main.css';
export default styles;
